var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'has-error': _vm.errorMessages.length > 0}},[_c('editor',_vm._g({ref:"editor",attrs:{"disabled":_vm.disabled,"value":_vm.value,"model-events":"change keydown blur focus paste input","api-key":"q20nemaanvbywzuwgisyaugqa8gd8e05n9zmfeffi0o8wo5z","init":{
      placeholder: 'Question answer',
      branding: false,
      menubar: false,
      plugins: 'lists link image autoresize code paste media',
      paste_as_text: false,
      min_height: 300,
      skin: 'webcomet',
      content_css: 'webcomet',
      relative_urls: false,
      convert_urls: false,
      toolbar: 'bold italic underline | fontsizeselect | bullist numlist | link | image | media',
      media_live_embeds: true,
      content_style: `
        @import url('/assets/css/roboto.css');

        .mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before {
          color: rgba(0, 0, 0, 0.6);
          font-weight: 400;
          font-family: 'Roboto';
          font-size: 16px;
        }

        .mce-content-body {
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }
      `
    }},on:{"input":_vm.handleInput}},_vm.$listeners)),_vm._v(" "),_c('div',{staticClass:"pl-3 mt-2"},[_c('VMessages',{attrs:{"value":_vm.internalErrorMessages,"color":"error"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }